import {IntermediatePart} from "../../intermediatePart";
import store from "../../../../../store";
import {getFeatureIsLocked} from "../../../../../misc/helpers";

export default class Microwave extends IntermediatePart {
  constructor(isChild) {
    super(isChild);
    this.partId = 'microwave';
    this.partName = 'Microwave';
    this.translateId = "visualizer.kitchen.appliance.microwave";
    this.canBeDisabled = true;
  }

  load(dbFeature) {
    return super.load_(dbFeature, new Microwave());
  }

  handleClick(ignoreLocked = false, clickFrom = "") {
    const {isEncore} = store.getState().fabricatorState;
    if (isEncore) {
      const featureIsLocked = getFeatureIsLocked(this, ignoreLocked);
      if (ignoreLocked || !featureIsLocked) {
        const applianceParent = this.getParent().getParent();
        if (applianceParent.layout.type === 6) {
          if (applianceParent.stovetop && !applianceParent.stovetop.disabled) {
            applianceParent.stovetop.disabled = true;
          }
          if (applianceParent.oven && !applianceParent.oven.disabled) {
            applianceParent.oven.disabled = true;
          }
          if (applianceParent.range && applianceParent.range.disabled) {
            applianceParent.range.disabled = false;
          }
        }
      }
    }
    return super.handleClick(ignoreLocked, clickFrom);
  }

  disabledClick() {
    const applianceParent = this.getParent();
    if ((applianceParent.layout.type === 6) && !this.disabled && applianceParent.hood
      && !applianceParent.hood.disabled) {
      applianceParent.hood.disabled = true;
    }
  }

}
